import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=623af8e9&scoped=true&"
import script from "./Numbers.vue?vue&type=script&lang=ts&"
export * from "./Numbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623af8e9",
  null
  
)

export default component.exports